import React from "react";
import { Link } from "react-router-dom";
import aktualnosciData from "./aktualnosciData";

const AktualnosciMini = () => {
    const truncate = (content, max) =>
        content.length <= max ? content : content.slice(0, max) + "...";

    return (
        <div className="bg-[#0d0d0d] px-4 sm:px-8 lg:px-16 xl:px-40 py-16">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-center text-white mb-3 tracking-widest uppercase">
                Aktualności
            </h1>
            <div className="w-16 h-px bg-red-500 mx-auto mb-14" />
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                {aktualnosciData.slice(0, 3).map((data, index) => (
                    <Link
                        to={`/rozszeszenie/${data.id}`}
                        key={index}
                        className="group block bg-[#161616] border border-white/5 rounded-xl overflow-hidden hover:border-red-500/30 transition-all duration-300"
                    >
                        <div className="overflow-hidden">
                            <img
                                className="w-full h-48 object-cover object-center group-hover:scale-105 transition-transform duration-500"
                                src={data.image}
                                alt={data.title}
                            />
                        </div>
                        <div className="p-6">
                            <h2 className="text-lg font-semibold text-white leading-snug mb-3 group-hover:text-red-400 transition-colors duration-200">
                                {data.title}
                            </h2>
                            <p className="text-sm leading-relaxed text-gray-500">
                                {truncate(data.content, 160)}
                            </p>
                            <p className="mt-4 text-xs text-red-400 uppercase tracking-widest font-semibold">
                                Czytaj więcej »
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
            <div className="text-center mt-10">
                <a
                    href="/aktualnosci"
                    className="inline-block px-6 py-2 text-sm text-gray-400 border border-white/15 rounded-lg hover:border-red-500/60 hover:text-red-400 transition-all duration-200 tracking-widest"
                >
                    POKAŻ WIĘCEJ
                </a>
            </div>
        </div>
    );
};

export default AktualnosciMini;